import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=794611bc&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"
import style0 from "./Image.vue?vue&type=style&index=0&id=794611bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794611bc",
  null
  
)

export default component.exports